import React from "react";

/**
 * Role-agnostic empty / loading state for dashboards and public surfaces.
 * Pass statusRole="status" while loading so assistive tech announces progress.
 */
export default function EmptyState({
  title,
  message,
  children,
  statusRole = undefined,
}) {
  return (
    <div
      className="dashboard-empty-state text-center"
      style={{ padding: "2rem 1rem" }}
      role={statusRole}
      aria-live={statusRole ? "polite" : undefined}
    >
      {title ? <h4 className="mb-2">{title}</h4> : null}
      {message ? (
        <p className={`text-muted ${children ? "mb-3" : "mb-0"}`}>{message}</p>
      ) : null}
      {children}
    </div>
  );
}
